import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";

import AkkhorLayout from "../../layout/AkkhorLayout";
import AlertErrorForm from "../../component/AlertErrorForm";
import { HexColorPicker } from "react-colorful";

export default function PipelineForm() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);

    const defaultdetail = {
        author_id: user.data.id,
        title: '',
        alias: '',
        color: '#aabbcc',
        status: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "pipeline_settings/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            // console.log(res.data.data)
                            if (mounted) {
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, autoRefresh]
    );
    let validForm = {
        title: Yup.string().trim().nullable().required('Nhập tiêu đề').max(250, "Độ dài không quá 250 ký tự"),
        position: Yup.string().trim().nullable().required('Vui lòng nhập vị trí'),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];
            setLoading(true)
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'pipeline_settings/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật pipeline thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'pipeline_settings', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();

                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới pipeline thành công',
                            buttons: [{ label: 'OK' }]
                        });
                        window.location.reload()
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="pipeline_settings">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/pipeline_settings">Cài đặt Pipeline</Link>
                    </li>
                    <li>{id ? 'Sửa Pipeline' : 'Thêm mới Pipeline'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} Pipeline</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-sm-4 col-12 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>

                            <div className="col-sm-4 col-12 form-group">
                                <label>Vị trí <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("position")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="position"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Màu nền</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("header_color")} autoComplete="off" />
                                <HexColorPicker className="mt-2" color={formik.values['header_color'] ? formik.values['header_color'] : "#FFF"} onChange={(e) => formik.setFieldValue('header_color', e)} />
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Màu chữ</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("text_color")} autoComplete="off" />
                                <HexColorPicker className="mt-2" color={formik.values['text_color'] ? formik.values['text_color'] : "#FFF"} onChange={(e) => formik.setFieldValue('text_color', e)} />
                            </div>
                            <div className="col-12"></div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Thời hạn (phút)</label>
                                <input type="text" placeholder="VD: 5" className="form-control height32" {...formik.getFieldProps("timming")} autoComplete="off" />
                            </div>
                            <div className="col-12 mb-3"><small>Sau khoảng thời gian t phút, user không có tác động tới Pinepline thì sẽ tự động chuyển về trạng thái đã định</small></div>
                            <div className="col-12"></div>
                             <div className="col-sm-4 col-12 form-group">
                                <label>Hiển thị trên trang: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("inpage")}>
                                    <option value="customers" >Khách hàng của tôi</option>
                                    <option value="dachot" >Khách hàng đã chốt</option>
                                </select>
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Sau trạng thái này khách hàng sẽ chuyển sang trang "Quản lý giao dịch và khách hàng": </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("finish")}>
                                    <option value="1" >Có</option>
                                    <option value="0" >Không</option>
                                </select>
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Trạng thái: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("status")}>
                                    <option value="1" >Đang hoạt động</option>
                                    <option value="0" >Ngưng hoạt động</option>
                                </select>
                            </div>

                            <div className="col-12 mt-3" ></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{loading ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
